module.exports = __webpack_public_path__ + "static/media/angle.10a0f4ca.svg";